export default {
  en: {
    actions: {
      favorite: {
        on: 'Add to favorites',
        off: 'Remove from favorites',
      },
      subscribe: {
        on: 'Subscribe',
        off: 'Unsubscribe',
      },
      block: {
        on: 'Block group',
        off: 'Unblock group',
      },
      inappropriate_report: 'Report as inappropriate',
      leave: 'Leave group',
      settings: 'Settings',
      admin: 'Admin',
    },
    snack: {
      favorite: {
        on: 'Group added to favorites',
        off: 'Group removed from favorites',
      },
      subscribe: {
        on: 'Successfully subscribed',
        off: 'Successfully unsubscribed',
      },
      block: {
        on: 'Successfully blocked',
        off: 'Successfully unblocked',
        confirm:
          "Are you sure?\n• You won't see any content from the group\n• You will not see the group in the group overview\n• The group can't send you any invitations",
      },
    },
  },
};
